import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { NotificationGateway } from 'src/app/application/gateway/NotificationGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';
import { ExportOfferCreateOptionComponent } from '../export-offer/export-offer-create-option/export-offer-create-option.component';
import { ProfileUtils } from '../../util/profile-utils';
import { SecurityGateway } from 'src/app/application/gateway/SecurityGateway';
import { driver } from 'driver.js';
import { ExportOfferGateway } from 'src/app/application/gateway/ExportOfferGateway';
import { ExportOfferInformation } from 'src/app/domain/models/ExportOffer';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css'],

})
export class UserDashboardComponent implements OnInit {
  @Input()
  userMenuActiveItemIndex: number = 0

  @Input()
  public activeItem: any | undefined

  @Input()
  public fullScreen: boolean = false

  displaySidebar: boolean = false

  items: MenuItem[] = []
  itemsUnauth: MenuItem[] = []

  profile: BasicUser | undefined
  isExporter: boolean = false;
  visibleCreateExportOfferOptionDialog: boolean = false

  fromTo: string = '';
  adsCode: string | null = '';

  urlSegment1: string | null = null;
  urlSegment2: string | null = null;
  urlSegment3: string | null = null;

  isMarketplace: boolean = false

  materialIconsReady = false;

  isMobile: boolean = false;

  selectedMenuItem: string = '';

  selectedFlow: string = '';

  exporterMarketplaceMenuItems: MenuItem[] = []
  exporterProgramMenuItems: MenuItem[] = []
  importerMarketplaceMenuItems: MenuItem[] = []

  visibleInvite: boolean = false

  loading: boolean = false

  driverObj = driver({
  showProgress: true,
  popoverClass: 'driverjs-theme',
    steps: [
      { element: '#goMarketplace', popover: { title: 'Title', description: 'Aquí puede visitar nuestro Marketplace' } }
    ]
  });

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _authService: AuthGateway,
    private _profileService: ProfileGateway,
    private _notificationService: NotificationGateway,
    public translate: TranslateService,
    private _activatedRoute: ActivatedRoute,
    private readonly _securityService: SecurityGateway,
    private readonly _exportOfferService: ExportOfferGateway,
    private readonly _directSaleProgramService: DirectSaleProgramGateway
  ) {
      this._activatedRoute.queryParams.subscribe(queryParams => {
        this.fromTo = queryParams['fromTo'];
      })

      // TODO aleyton: ajustar con valor retornado de endpoint
      this.selectedFlow = localStorage.getItem('_selected_flow') ?? '';
  }

  ngOnInit(): void {
    this.checkDeviceType();
    window.addEventListener('resize', this.onResize.bind(this));

    if (this._router.url === '/marketplace') {
      this.isMarketplace = true;
    } else {
      this.isMarketplace = false;
    }

    this.profile = this._authService.getUser()
    if(this.profile) {
      this.translate.use(this.profile.lang)

      if(this.profile.type == 1){
        this.isExporter = true;
      }

      if(this._authService.isAuthenticated()) {
        this.configureMenus()
      }
    }

    this._activatedRoute.paramMap.subscribe(params => {
      this.adsCode = params.get('adsCode');
    });

    // Obtenemos los segmentos de la URL
    const urlSegments = this._activatedRoute.snapshot.url;

    if (urlSegments.length > 0) {
      this.urlSegment1 = urlSegments[0]?.path;
    }
    if (urlSegments.length > 1) {
      this.urlSegment2 = urlSegments[1]?.path;
    }
    if (urlSegments.length > 2) {
      this.urlSegment3 = urlSegments[2]?.path;
    }


    this.itemsUnauth = [
      {
        label: 'Home',
        icon: 'material-symbols home-icon',
        routerLink: ['/' + Routes.homePage],
        routerLinkActiveOptions: { exact: true }
      },
      {
        label: 'Marketplace',
        icon: 'material-symbols nutrition-icon',
        routerLink: ['/' + Routes.externalMarketplace]
      },
    ]
  }

  ngAfterViewInit(){
    document.fonts.ready.then(() => {
      this.materialIconsReady = true;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeItem']) {
      //console.log('activeItem ha cambiado:', changes['activeItem'].currentValue);
    }
  }

  isActiveItem(item: MenuItem): boolean {
    return this.activeItem === item.label; // Compara el ítem actual con el ítem activo
  }

  private configureMenus() {
    this.translate.get([
      'UserDashboardComponent.UserDashboardMenu.LoadOrderTitle',
      'UserPages.UserLoadOrders.PageTitle',
      'UserDashboardComponent.UserDashboardMenu.ImportOrderTitle',
      'UserDashboardComponent.UserDashboardMenu.CurrentImportOrdersLabel',
      'UserDashboardComponent.UserDashboardMenu.PossiblePurchaseImportOrdersLabel',
      'UserDashboardComponent.UserDashboardMenu.ClosedSaleLabel',
      'UserDashboardComponent.UserDashboardMenu.ClosedSaleProgramationLabel',
      'UserDashboardComponent.UserDashboardMenu.ExportOfferTitle',
      'UserDashboardComponent.UserDashboardMenu.MarketplaceExportOfferLabel',
      'UserDashboardComponent.UserDashboardMenu.ClosedSaleExportOfferLabel',
      'UserDashboardComponent.UserDashboardMenu.FrozenFruitExportOfferLabel',
      'UserDashboardComponent.UserDashboardMenu.ExportOfferSuggestionTitle',
      'UserDashboardComponent.UserDashboardMenu.ExportOfferSuggestionLabel',
      'UserDashboardComponent.UserDashboardMenu.ImportRequestTitle',
      'UserDashboardComponent.UserDashboardMenu.ImportRequestLabel',
      'UserDashboardComponent.UserDashboardMenu.NegotiationTitle',
      'UserDashboardComponent.UserDashboardMenu.NegotiationLabel',
      'UserDashboardComponent.UserDashboardMenu.FridgestorageTitle',
      'UserDashboardComponent.UserDashboardMenu.FridgestorageLabel',
      'UserDashboardComponent.UserDashboardMenu.ProductCertificateTitle',
      'UserDashboardComponent.UserDashboardMenu.ProductCertificateLabel',
      'UserDashboardComponent.UserDashboardMenu.QCReviewsTitle',
      'UserDashboardComponent.UserDashboardMenu.OriginQCReviewsLabel',
      'UserDashboardComponent.UserDashboardMenu.OriginQCReviewedsLabel',
      'UserDashboardComponent.UserDashboardMenu.DestinationQCReviewsLabel',
      'UserDashboardComponent.UserDashboardMenu.DestinationQCReviewedsLabel',
      'UserDashboardComponent.UserDashboardMenu.UserPanelLabel',
      'UserDashboardComponent.UserDashboardMenu.ProgramLabel',
      'UserDashboardComponent.UserDashboardMenu.ForwarderReviewsTitle',
      'UserDashboardComponent.UserDashboardMenu.OriginForwarderReviewsLabel',
      'UserDashboardComponent.UserDashboardMenu.OriginForwarderReviewedsLabel',
      'UserDashboardComponent.UserDashboardMenu.CompanyInfoLabel',
      'UserDashboardComponent.UserDashboardMenu.CustomAgentReviewsTitle',
      'UserDashboardComponent.UserDashboardMenu.OriginCustomAgentReviewsLabel',
      'UserDashboardComponent.UserDashboardMenu.OriginCustomAgentReviewedsLabel',
      'UserDashboardComponent.UserDashboardMenu.ForwarderOrdersLabel',
      'UserDashboardComponent.UserDashboardMenu.ProgramReportsTitle',
      'UserDashboardComponent.UserDashboardMenu.PurchaseOrdersLabel',
      'UserDashboardComponent.UserDashboardMenu.InviteToFruztyLabel',
      'UserDashboardComponent.UserDashboardMenu.NewProgramLabel',
      'UserDashboardComponent.UserDashboardMenu.LastProgramLabel',
      'UserDashboardComponent.UserDashboardMenu.MasterLabel',
      'UserDashboardComponent.UserDashboardMenu.ContainerLabel',
      'UserDashboardComponent.UserDashboardMenu.PalletLabel',
      'UserDashboardComponent.UserDashboardMenu.HomeTitle',
      'UserMenuComponent.HelpMenuItems.CustomerHelpLabel',
      'HomeHeader.UserDashboard.NewImportRequestButton',
      'HomeHeader.UserDashboard.NewOfferButton',
      'HomeHeader.UserMenu.MySellsButton',
      'HomeHeader.UserDashboard.NewProgramButton',
      'HomeHeader.UserMenu.MyPurchaseButton',
      'HomeHeader.UserMenu.AccountItem',
      'HomeHeader.UserMenu.LogoutToolTip',
      'UserDashboardComponent.UserDashboardMenu.UserStockPallets',
      'UserDashboardComponent.UserDashboardMenu.FormatStock'
    ]).subscribe({
      next: (tranlations) => {
        if(this.profile) {
          this.items = [];

          if (!this.isMobile) {
            this.items.push(
              {
                label: tranlations['UserDashboardComponent.UserDashboardMenu.UserPanelLabel'],
                icon: 'material-symbols person-icon',
                visible: this.profile.type === 1 || this.profile.type === 2,
                routerLink: ['/' + Routes.userPanelPage]
              }
            )
          }
          else {
            this.items.push(
              {
                label: tranlations['UserDashboardComponent.UserDashboardMenu.HomeTitle'],
                icon: 'material-symbols home-icon',
                visible: this.profile.type === 1 || this.profile.type === 2,
                routerLink: ['/'],
                routerLinkActiveOptions: { exact: true }
              }
            )
          }

          this.items.push(
            // 1 = Exporter, 2 = Importer
            {
              label: 'Marketplace',
              visible: (this.profile.type === 1 || this.profile.type == 2) && this.selectedFlow?.includes('marketplace'),
              expanded: this.selectedFlow === 'marketplace',
              styleClass: 'panel-subtitle',
              items: [
                {
                  label: 'Marketplace',
                  visible: this.profile.type === 1 || this.profile.type == 2,
                  icon: 'material-symbols nutrition-icon',
                  routerLink: ['/' + Routes.marketplacePage],
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.MarketplaceExportOfferLabel'],
                  icon: 'material-symbols sell-icon',
                  routerLink: ['/' + Routes.userExportOffers],
                  visible: this.profile.type === 1, // Exporter
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.ImportOrderTitle'],
                  icon: 'material-symbols orders-icon',
                  routerLink: ['/' + Routes.userImportOrdersCurrent],
                  visible: this.profile.type === 1 || this.profile.type === 2,
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.LoadOrderTitle'],
                  icon: 'material-symbols table-view-icon',
                  routerLink: ['/' + Routes.userLoadOrders],
                  visible: this.profile.type === 1 || this.profile.type === 2,
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.ImportRequestLabel'],
                  icon: 'material-symbols sell-icon',
                  routerLink: ['/' + Routes.userImportRequest],
                  visible: this.profile.type === 2, // Importer
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.NegotiationLabel'],
                  icon: 'material-symbols currency-exchange-icon',
                  routerLink: ['/' + Routes.userBargaining],
                  visible: this.profile.type === 1 || this.profile.type === 2,
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.ExportOfferSuggestionLabel'],
                  icon: 'material-symbols reviews-icon',
                  routerLink: ['/' + Routes.userExportOfferSuggestionPage],
                  visible: this.profile.type === 2, // Importer
                }
              ],
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.ProgramLabel'],
              visible: (this.profile.type === 1 || this.profile.type == 2) && this.selectedFlow?.includes('program'),
              expanded: this.selectedFlow === 'program',
              styleClass: 'panel-subtitle',
              items: [
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.ProgramLabel'],
                  icon: 'material-symbols calendar-month-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: ['/' + Routes.userClosedSales]
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.PurchaseOrdersLabel'],
                  icon: 'material-symbols orders-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: ['/' + Routes.userClosedSalesPurchaseOrders]
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.InviteToFruztyLabel'],
                  icon: 'material-symbols person-add-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  command: () => this.showInvite()
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.NewProgramLabel'],
                  icon: 'material-symbols calendar-add-on-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: ['/' + Routes.userDirectSaleCreate],
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.LastProgramLabel'],
                  icon: 'material-symbols calendar-clock-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  command: () => this.findLastProgram()
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.UserStockPallets'],
                  icon: 'material-symbols inventory-icon', // Exporter
                  visible: this.profile.type === 1,
                  routerLink: ['/' + Routes.userStockPallet]
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.FormatStock'],
                  icon: 'material-symbols receipt-icon', // Exporter
                  visible: this.profile.type === 1,
                  routerLink: ['/' + Routes.userFormatStockPallet]
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.ProgramReportsTitle'],
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: '',
                  styleClass: 'panel-subtitle panel-inner-title'
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.ProgramReportsTitle'],
                  icon: 'material-symbols table-view-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: ['/' + Routes.userLoadOrdersProgram]
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.MasterLabel'],
                  icon: 'material-symbols table-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: ['/' + Routes.userLoadMasterOrdersProgram]
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.ContainerLabel'],
                  icon: 'material-symbols view-column-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: ['/' + Routes.userLoadContainersOrdersProgram]
                },
                {
                  label: tranlations['UserDashboardComponent.UserDashboardMenu.PalletLabel'],
                  icon: 'material-symbols pallet-icon',
                  visible: this.profile.type == 1 || this.profile.type == 2,
                  routerLink: ['/' + Routes.userLoadPalletsOrdersProgram]
                }
              ]
            },
            // 4 = QC User
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.QCReviewsTitle'],
              visible: this.profile.type === 4,
              styleClass: 'panel-subtitle',
              disabled: true,
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.OriginQCReviewsLabel'],
              icon: 'material-symbols schedule-icon',
              visible: this.profile.type === 4,
              routerLink: ['/' + Routes.qcUserReviews]
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.OriginQCReviewedsLabel'],
              icon: 'material-symbols content-paste-search-icon',
              visible: this.profile.type === 4,
              routerLink: ['/' + Routes.qcUserOriginReviewed]
            },
            // 5 = Forwarder
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.ForwarderReviewsTitle'],
              visible: this.profile.type === 5,
              styleClass: 'panel-subtitle',
              disabled: true
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.OriginForwarderReviewsLabel'],
              icon: 'material-symbols schedule-icon',
              visible: this.profile.type === 5,
              routerLink: ['/' + Routes.forwarderUserReviews]
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.OriginForwarderReviewedsLabel'],
              icon: 'material-symbols content-paste-search-icon',
              visible: this.profile.type === 5,
              routerLink: ['/' + Routes.forwarderUserOriginReviewed]
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.CompanyInfoLabel'],
              icon: 'material-symbols domain-icon',
              visible: this.profile.forwardAdmin,
              routerLink: ['/' + Routes.forwarderUsers]
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.ForwarderOrdersLabel'],
              icon: 'material-symbols orders-icon',
              visible: this.profile.type === 5,
              routerLink: ['/' + Routes.forwarderImportOrders]
            },
            // 6 = Custom Agent
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.CustomAgentReviewsTitle'],
              visible: this.profile.type === 6,
              styleClass: 'panel-subtitle',
              disabled: true
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.OriginCustomAgentReviewsLabel'],
              icon: 'material-symbols schedule-icon',
              visible: this.profile.type === 6,
              routerLink: ['/' + Routes.customAgentUserReviews]
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.OriginCustomAgentReviewedsLabel'],
              icon: 'material-symbols content-paste-search-icon',
              visible: this.profile.type === 6,
              routerLink: ['/' + Routes.customAgentUserOriginReviewed]
            },
            {
              label: tranlations['UserDashboardComponent.UserDashboardMenu.CompanyInfoLabel'],
              icon: 'material-symbols domain-icon',
              visible: this.profile.customAgentAdmin,
              routerLink: ['/' + Routes.customAgentUsers]
            }
            //
          )

          this.importerMarketplaceMenuItems = [
            {
              label: tranlations['HomeHeader.UserDashboard.NewImportRequestButton'],
              routerLink: ['/' + Routes.userNewImportRequest]
            },
            {
              label: tranlations['HomeHeader.UserMenu.MyPurchaseButton'],
              routerLink: ['/' + Routes.userImportOrdersCurrent]
            },
          ]

          this.exporterMarketplaceMenuItems = [
            {
              label: tranlations['HomeHeader.UserDashboard.NewOfferButton'],
              routerLink: '',
              command: () => this.openCreateExportOfferOptionDialog()
            }
          ]

          this.exporterProgramMenuItems = [
            {
              label: tranlations['HomeHeader.UserDashboard.NewProgramButton'],
              routerLink: ['/' + Routes.userDirectSaleCreate]
            }
          ]
        }
      },
      error: (e) => {
        console.log(e)
      }
    })
  }

  get userCompleteName(): string {
    if(this.profile) {
      return this.profile.contactName
    }
    return ''
  }

  get profileName(): string {
    if(this.profile) {
      if(this.profile.lang === 'es'){
        return ProfileUtils.getTypeNameEs(this.profile.type);
      }else{
        return ProfileUtils.getTypeName(this.profile.type);
      }
    }
    return ''
  }

  get profileCompanyName(): string {
    if(this.profile) {
      return this.profile.companyName
    }
    return ''
  }

  onClickMenuOption(name: string) {
    this.selectedMenuItem = name;
    if (name === 'account') {
      this.goToUserPanel();
    }
    else if (name === 'help') {
      this.goToHelp();
    }
    else {
      this.logout();
    }
  }

  @ViewChild(ExportOfferCreateOptionComponent) exportOfferCreateOptionComponent: ExportOfferCreateOptionComponent | undefined
  openCreateExportOfferOptionDialog() {
    this.exportOfferCreateOptionComponent?.reset()
    this.visibleCreateExportOfferOptionDialog = true
  }

  onActiveItemChange(event: any) {
    this.activeItem = event
  }

  get isAuthenticated(): boolean {
    return this._authService.isAuthenticated()
  }

  get contentCssClass(): string {
    let clases = '';

     this.fullScreen ?  clases += 'w-full h-full main-bg-color' : clases += 'md:col-12 lg:col-10 lg:p-3 md:p-3 main-bg-color';

     this.activeItem == 'marketplace' ? clases += 'marketplace-background': clases;

     return clases;
  }

  get withStyle(): string {

    let style = ''

    this.activeItem == 'home' ? style+= 'max-width: 1280px;' : style;

    return style;
  }

  goCreateOffers() {
    this._router.navigate(['/' + Routes.newExportOffer, '']);
  }

  goToCreateImportOrderRequeriment() {
    this._router.navigate(['/' + Routes.userNewImportRequest]);
  }

  goToLogin() {
    if(this.urlSegment1 == 'offers' && !this.urlSegment2 && !this.urlSegment3){
      this._router.navigate(['/', Routes.login],{
        queryParams: { fromTo: 'offers' }
      })
    }
    else if(this.urlSegment1 == 'offer-detail' && this.urlSegment2 && !this.urlSegment3 && this.adsCode){
      this._router.navigate(['/', Routes.login],{
        queryParams: { fromTo: 'offer-detail', adsCode: this.adsCode }
      })
    }
    else {
      this._router.navigate(['/'+ Routes.login])
    }
  }

  goToHome()
  {
    this._router.navigate(['/' + Routes.homePage]);
  }

  goToMarketplaceAd()
  {
    if(this.isAuthenticated){
      this._router.navigate(['/' + Routes.marketplacePage]);
    }else{
      this._router.navigate(['/' + Routes.externalMarketplace]);
    }

  }

  isActive(route: string): boolean {
    return this._router.url === route;
    //return this._router.url === '/' + route;

  }

  goToMarketplace() {
    this._router.navigate(['/' + Routes.marketplacePage])
  }

  goToExportOffers() {
    this._router.navigate([Routes.userExportOffers])
  }

  goToImportOrders() {
    this._router.navigate(['/' + Routes.userImportOrdersCurrent])
  }

  goToUserPanel() {
    this._router.navigate(['/' + Routes.userPanelPage])
  }

  goToHelp() {
    this._router.navigate(['/' + Routes.userSupport])
  }

  goToUserContactInfo() {
    this._router.navigate(['/' + Routes.userContactInfo])
  }

  goToProgram() {
    this._router.navigate(['/' + Routes.userClosedSales])
  }

  goToCreateProgram() {
    this._router.navigate(['/' + Routes.userDirectSaleCreate])
  }

  onResize() {
    this.checkDeviceType();
  }

  goToAdminPanel()
  {
    this._router.navigate(['/', Routes.adminManageOrderPage])
  }

  checkDeviceType() {
    if (window.innerWidth <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    if(this._authService.isAuthenticated()) {
      this.configureMenus()
    }
  }

  logout(): void {
    this._securityService.doLogout().subscribe({
      next: (v) => {
        this._authService.logout()
        this._router.navigate([Routes.login])
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.System.LogoutFailed') });
      },
      complete: () => {}
    })
  }

  showInvite() {
    this.visibleInvite = true;
  }

  findLastProgram() {
    if (this.profile?.type === 1) {
      this.findExporterLastProgram()
    }
    else {
      this.findImporterLastProgram()
    }
  }

  findExporterLastProgram() {
    this.loading = true
    this._exportOfferService.getAllClosedSaleByExporter(this._authService.getUsername()).subscribe({
      next: (v) => {
        this.loading = false

        const lastModifiedOffer = this.getElementByLastDate(v)
        if (lastModifiedOffer !== undefined) {
          sessionStorage.removeItem('_close_sale_month');
          this._router.navigate(['/' + Routes.exporterClosedSaleOrdersPage, lastModifiedOffer.directSalePrograms[0].guid])
        }
        else {
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.DirectSaleDetail.LastProgramErrorText')});
        }
      },
      error: () => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.ExportOffer.ManyRetrieveError') })
      }
    })
  }

  findImporterLastProgram() {
    this.loading = true
    this._directSaleProgramService.getDirectSaleImporter().subscribe({
      next: (v) => {
        this.loading = false

        const lastModifiedOffer = this.getElementByLastDate(v)
        if (lastModifiedOffer !== undefined) {
          sessionStorage.removeItem('_close_sale_month');
          this._router.navigate(['/' + Routes.importerClosedSaleOrdersPage, lastModifiedOffer.directSalePrograms[0].guid])
        }
        else {
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.DirectSaleDetail.LastProgramErrorText')});
        }
      },
      error: () => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Importer.ManyRetrieveError') })
      }
    })
  }

  getElementByLastDate(items: ExportOfferInformation[]): ExportOfferInformation | undefined {
    if (items.length > 0) {
      items.sort((a, b) => {
        if (b.exportOffer.lastModified && a.exportOffer.lastModified) {
          return new Date(b.exportOffer.lastModified).getTime() - new Date(a.exportOffer.lastModified).getTime()
        }
        return 0
      });
      return items[0];
    }
    return undefined
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.onResize.bind(this));
  }
}
